<template>
  <div id="footer">
    <div class="footer_nav">
      <ul class="nav_name" v-for="(item,index) in navList" :key="index">
        <li>{{item.menuName}}</li>
        <ul class="nav_item_name" v-for="(target,index) in item.children" :key="target.id">
          <li>
            <router-link v-if="target.id == 4" :to="{path:'/location',query:{menuId:8,plateId:4}}">
              <span>地理位置</span>
            </router-link>
            <router-link v-else-if="target.id == 7" :to="{path:'/applyForEnter',query:{menuId:15,plateId:7}}">
              <span >申请入驻</span>
            </router-link>
            <router-link v-else :to="{path: '/articleList', query: {menuId: item.menuId,plateId:target.id}}">
              <span>{{target.plateName}}</span>
            </router-link>
          </li>
        </ul>
      </ul>
    </div>
    <div class="copy_right">
      <p>Copyright ©2019 茂名高新区国家级科技企业孵化器 版权所有</p>
      <a href="http://www.miitbeian.gov.cn" target="_blank">粤ICP备17130558号-3</a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navList: this.$store.state.app.static.slice(0, -1),
      }
    },
    created() {
      console.log(this.navList)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #333;
    .footer_nav {
      width: 1200px;
      color: #fff;
      border-bottom: 1px solid #fff;
      padding-bottom: 30px;
      display: flex;
      .nav_name {
        width: 40%;
        font-size: 18px;
        margin-top: 30px;
        padding-left: 5%;
        li {
          line-height: 76px;
        }
        .nav_item_name {
          li {
            line-height: 34px;
            a {
              width: 100%;
              color: #fff;
              font-size: 16px;
            }
          }
        }
      }
    }
    .copy_right {
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      p {
        line-height: 60px;
        font-size: 16px;
        color: #fff;
      }
      a {
        line-height: 60px;
        font-size: 14px;
      }

    }

  }
</style>
